import { render, staticRenderFns } from "./customers-table.vue?vue&type=template&id=2f81b663&"
import script from "./customers-table.vue?vue&type=script&lang=ts&"
export * from "./customers-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports